module.exports = __webpack_public_path__ + "img/shu.424b772c.gif";